import React, { useState } from 'react'
import classNames from "classnames";
import { useTranslation } from 'react-i18next'
import { Modal, Button, Form } from 'react-bootstrap'

import styles from './index.module.scss';

export default function NoticeModal ({ show, toggleWarngingModal }) {
  const [hasAgree, setHasAgree] = useState(false);
  const { t } = useTranslation()

  return (
    <Modal show={show} centered backdrop="static" dialogClassName={styles.modalDialog} onHide={() => toggleWarngingModal(false)}>
      <Modal.Header className="bg-primary text-white flex-column align-items-start px-4">
        <h3 className="m-0">{t('warning.title')}</h3>
      </Modal.Header>
      <Modal.Body className={classNames(styles.modalBody, 'px-4')}>
        <ol className={styles.content}>
          <li>
            {t('warning.firstContent')}
          </li>
          <li>
            {t('warning.secondContent')}
          </li>
          <li>
            {t('warning.thirdContent')}
          </li>
        </ol>
      </Modal.Body>
      <Modal.Footer className={classNames('justify-content-between', 'align-items-center', styles.modalFooter)}>
        <Form.Check color="primary" className={styles.checkbox} label={t('warning.agree')} id="agree" value={hasAgree} onChange={() => setHasAgree(!hasAgree)}></Form.Check>
        <Button variant="primary" className={styles.startBtn} disabled={!hasAgree} onClick={() => toggleWarngingModal(false)}>{t('warning.startTour')}</Button>
      </Modal.Footer>
    </Modal >
  )
}
